import { css } from '@emotion/react';
import { COLORS } from "../../constants/Theme";
export function getColor(variant) {
    switch (variant) {
        case 'default':
        case 'readonly':
            return `${COLORS.text.primary}`;
        case 'selected':
            return `${COLORS.content.positive}`;
        case 'inactive':
            return `${COLORS.content.inactive}`;
        case 'error':
            return `${COLORS.content.negative}`;
        case 'placeholder':
            return `${COLORS.content.placeholder}`;
        default:
            return `${COLORS.text.primary}`;
    }
}
export function getTheme(variant, version) {
    switch (variant) {
        case 'default':
            return css `
				cursor: pointer;
				color: ${COLORS.text.primary};
				background-color: ${COLORS.surface.standard};
				&:hover {
					background-color: ${COLORS.surface.subdued};
				}
			`;
        case 'selected':
            return css `
				color: ${COLORS.content.positive};
				background: ${COLORS.background.positive.light};
				box-shadow: ${version === '2.0'
                ? '0'
                : '0 2px 8px rgba(0, 0, 0, 0.12)'};
			`;
        case 'inactive':
            return css `
				color: ${COLORS.content.inactive};
				background-color: ${COLORS.surface.standard};
				cursor: not-allowed;
			`;
        case 'readonly':
            return css `
				color: ${COLORS.text.primary};
			`;
        case 'separator':
            return css `
				color: ${COLORS.content.inactive};
				background-color: ${COLORS.background.base};
				cursor: none;
				padding: 8px 16px;
			`;
        default:
            return css `
				color: ${COLORS.text.primary};
				background-color: ${COLORS.surface.standard};
				&:hover {
					background-color: ${COLORS.surface.subdued};
				}
			`;
    }
}
//# sourceMappingURL=themes.js.map